'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildStubbedThread = buildStubbedThread;

var _ThreadSources = require('conversations-schema/constants/ThreadSources');

var _buildConversation = require('conversations-schema/factories/ConversationFactory/buildConversation');

var _stubbedThreadId = require('../constants/stubbedThreadId');

function buildStubbedThread() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      currentUrl = _ref.currentUrl;

  return (0, _buildConversation.buildConversation)({
    source: _ThreadSources.LIVE_CHAT,
    threadId: _stubbedThreadId.STUBBED_THREAD_ID,
    currentUrl: currentUrl
  });
}